
import { Component, Vue } from "vue-property-decorator";
import Breadcrumb from "@/components/layout/breadcrumb.vue";
import VirRequest, {
  VirMp4Param,
  VirPinyinParam,
  VirMp3Param
} from "@/lib/model/vir/VirRequest";
import Auth from "@/lib/common/auth";
import VirEditor from "@/components/editor/vir-editor.vue";
import {
  VirImgList,
  VirImgListParam,
  VirListImgParam,
  VirImgDelParam
} from "@/lib/model/vir/VirRequest";
import VirUploadImg from "./VirUploadImg.vue";

class LocationOptions {
  label = "";
  value = "";
}

@Component({
  components: {
    Breadcrumb,
    VirEditor,
    VirUploadImg
  }
})
export default class VirManual extends Vue {
  name = "vir-manual";
  radioValue = 1;
  virSettingForm: VirMp4Param = new VirMp4Param();
  defaultBgUrl =
    "https://oss.hina.com/app/test/2021/01/14/6042fb1b274f551e0d1de36823775623.png";
  locationOptions: LocationOptions[] = [
    { label: "靠左", value: "-248" },
    { label: "居中", value: "0" },
    { label: "靠右", value: "+248" }
  ];
  videoOptions: LocationOptions[] = [{ label: "mp4", value: "mp4" }];
  ratioOptions: LocationOptions[] = [
    { label: "480p", value: "480" },
    { label: "720p", value: "720" },
    { label: "1080p", value: "1080" }
  ];
  whOptions: LocationOptions[] = [
    { label: "16:9", value: "856:480" },
    { label: "9:16", value: "480:856" },
    { label: "4:3", value: "640:480" },
    { label: "3:4", value: "480:640" },
    { label: "2:3", value: "480:720" }
  ];
  subtitlesOptions: LocationOptions[] = [{ label: "无", value: "0" }];
  qualitysOptions: LocationOptions[] = [
    { label: "默认", value: "0" },
    { label: "高", value: "1" }
  ];
  rules = this.virSettingForm.rules();
  virPinyinParam = new VirPinyinParam();
  virMp3Param = new VirMp3Param();
  pinyinList = [];
  audioUrl = ""; // 试听URL
  audioObj: any = "";
  textContent = ""; // 配音文本，展示给用户看的
  subTextContent = ""; //配音文本，传递给接口的
  sendContent = ""; //追加的内容
  virListImgParam: VirListImgParam = new VirListImgParam(); // 图片列表请求参数
  virImgDelParam: VirImgDelParam = new VirImgDelParam();
  fileList: VirImgList[] = new Array<VirImgList>();
  currentVirImgId = 0; // 当前选中的背景图片ID
  trigger = true;
  virLocationUrl =
    "https://oss.hina.com/app/hina/2021/04/28/fd025ee1172549653d1fa9ef04f309f5.png";

  mounted() {
    this.getImgList();
  }

  getImgList() {
    this.virListImgParam.companyId = parseInt(Auth.companyId);
    VirRequest.virListImg(this.virListImgParam).then(res => {
      if (res.code === 0) {
        this.fileList = res.data.list;
      }
    });
  }

  deleteImg(imgId: number) {
    this.virImgDelParam.companyId = parseInt(Auth.companyId);
    this.virImgDelParam.imgId = imgId;
    VirRequest.virDeleteImg(this.virImgDelParam).then(res => {
      if (res.code === 0) {
        this.getImgList();
      }
    });
  }

  checkImg(item: any) {
    this.currentVirImgId = item.imgId;
    this.virSettingForm.bgUrl = item.url;
  }

  resetBgUrl() {
    this.currentVirImgId = 0;
    this.virSettingForm.bgUrl = this.defaultBgUrl;
  }

  afterUpload(e: any) {
    console.log("afterUpload e: ", e);
    this.getImgList();
  }

  checkPinyin() {
    if (this.virSettingForm.text) {
      this.virPinyinParam.text = this.html2Text(this.virSettingForm.text);
      VirRequest.virPinyinMatch(this.virPinyinParam).then(res => {
        if (res.code === 0) {
          if (res.data.list) {
            // 多音字列表
            this.pinyinList = res.data.list;
            // 将多音字回写到输入框中
            const replaceTextArr: any[] = []; //需要替换字体颜色的文字
            res.data.list.forEach((pinyinItem: any) => {
              if (replaceTextArr.indexOf(pinyinItem.char) == -1) {
                replaceTextArr.push(pinyinItem.char);
              }
            });
            if (replaceTextArr.length) {
              replaceTextArr.forEach((sinItem: any) => {
                this.textContent = this.textContent.replace(
                  new RegExp(`${sinItem}`, "g"),
                  "<font color='#f59a23'>" + sinItem + "</font>"
                );
              });
            }
          }
        } else {
          this.$message.error(res.message);
        }
      });
    } else {
      this.$message.error("请输入需要配音的文本");
    }
  }

  previewAudio() {
    this.virMp3Param.companyId = parseInt(Auth.companyId);
    this.virMp3Param.title = this.virSettingForm.title;
    this.virMp3Param.text = this.html2Text(this.textContent);
    this.virMp3Param.textForApi = this.html2TextForApi(this.subTextContent);
    this.virMp3Param.spd = this.virSettingForm.spd;
    console.log("console: ", this.virMp3Param);
    this.audioUrl =
      "http://s3.xfyousheng.com/J9Q7O4EL/uploadResource/5/avatarserver/20210421/video/online_watermark_c4cf7ea4-16fa-4f3e-b9dc-0080067a03b9.mp3";
    if (this.virMp3Param.text && this.virMp3Param.textForApi) {
      VirRequest.virTestMp3(this.virMp3Param).then(res => {
        if (res.code === 0) {
          if (res.data.url) {
            this.audioUrl = res.data.url;
            console.log("this.audioObj: ", this.audioObj);
            if (this.audioObj) {
              this.audioObj.pause();
            }
            this.audioObj = new Audio(this.audioUrl);
            this.audioObj.play();
          }
        } else {
          this.$message.error(res.message);
        }
      });
    } else {
      this.$message.error("请输入需要配音的文本");
    }
  }
  saveDesc() {
    console.log("saveDesc");
  }
  setData(val: any) {
    this.virSettingForm.text = this.html2Text(val);
    this.textContent = this.px2Button(val.replace(/pre;/gis, "pre-wrap;"));
    this.subTextContent = val;
  }

  spdPause(spd: string) {
    let spdStr = "";
    if (spd === "0") {
      spdStr = "[w0]";
    } else if (spd === "1") {
      spdStr = "[p500]";
    } else if (spd === "2") {
      spdStr = "[p1000]";
    } else if (spd === "3") {
      spdStr = "[p2000]";
    }
    this.sendContent = spdStr;
    this.trigger = !this.trigger;
  }

  locationChange(e: any) {
    if (e < 0) {
      this.virLocationUrl =
        "https://oss.hina.com/app/hina/2021/04/28/15bb79b8f24d017eb756db71918a4748.png";
    } else if (e > 0) {
      this.virLocationUrl =
        "https://oss.hina.com/app/hina/2021/04/28/ec96e084f4da62deac928d0282cfd47a.png";
    } else {
      this.virLocationUrl =
        "https://oss.hina.com/app/hina/2021/04/28/fd025ee1172549653d1fa9ef04f309f5.png";
    }
  }

  createMp4() {
    // if (parseInt(this.virSettingForm.location) < 0) {
    //   this.virSettingForm.location =
    //     "-" + String(parseInt(this.virSettingForm.ratio) / 2);
    // } else if (parseInt(this.virSettingForm.location) > 0) {
    //   this.virSettingForm.location = String(
    //     parseInt(this.virSettingForm.ratio) / 2
    //   );
    // }
    // fix 竖屏情况下 location只能为0
    if (this.virSettingForm.wh) {
      if (this.virSettingForm.wh === "856:480") {
        this.virSettingForm.width = "856";
        this.virSettingForm.height = "480";
      } else if (this.virSettingForm.wh === "480:856") {
        this.virSettingForm.width = "480";
        this.virSettingForm.height = "856";
        this.virSettingForm.location = "0";
      } else if (this.virSettingForm.wh === "640:480") {
        this.virSettingForm.width = "640";
        this.virSettingForm.height = "480";
        if (parseInt(this.virSettingForm.location) < 0) {
          this.virSettingForm.location = "-141";
        } else if (parseInt(this.virSettingForm.location) > 0) {
          this.virSettingForm.location = "141";
        }
      } else if (this.virSettingForm.wh === "480:640") {
        this.virSettingForm.width = "480";
        this.virSettingForm.height = "640";
        this.virSettingForm.location = "0";
      } else if (this.virSettingForm.wh === "480:720") {
        this.virSettingForm.width = "480";
        this.virSettingForm.height = "720";
        this.virSettingForm.location = "0";
      }
    }

    this.virSettingForm.textForApi = this.html2TextForApi(this.subTextContent);
    if (!this.virSettingForm.text) {
      this.$message.error("请输入需要配音的文本");
      return;
    }
    if (!this.virSettingForm.title) {
      this.$message.error("请输入视频标题");
      return;
    }
    VirRequest.virCreateMp4(this.virSettingForm).then(res => {
      if (res.code === 0) {
        this.$message.success("创建成功");
        this.$router.push("/vir/manage");
      }
    });
  }

  html2TextForApi(item: any) {
    item = item.replace(/<div[^<>]*>/gis, "");
    item = item.replace(/<\/div>/g, "");

    item = item.replace(/<tbody[^<>]*>/gis, "");
    item = item.replace(/<tr[^<>]*>/gis, "");
    item = item.replace(/<td[^<>]*>/gis, "");
    item = item.replace(/<\/td>/g, "");
    item = item.replace(/<\/tr>/g, "");
    item = item.replace(/<\/tbody>/g, "");

    item = item.replace(/<table[^<>]*>/gis, "");
    item = item.replace(/<\/table>/g, "");
    item = item.replace(/<colgroup[^<>]*>/gis, "");
    item = item.replace(/<col[^<>]*>/gis, "");
    item = item.replace(/<\/col>/g, "");
    item = item.replace(/<\/colgroup>/g, "");

    item = item.replace(/<span[^<>]*>/gis, "");
    item = item.replace(/<\/span>/g, "");
    item = item.replace(/<font[^<>]*>/gis, "");
    item = item.replace(/<\/font>/g, "");
    item = item.replace(/<p>/g, "");
    item = item.replace(/<\/p>/g, "");

    // 中文双引号过滤
    item = item.replace(/ldquo/g, '"');
    item = item.replace(/rdquo/g, '"');

    item = item.replace(/\n/g, "");
    item = item.replace(/&/gi, "");
    item = item.replace(/;/gi, "");
    item = item.replace(/nbsp/gi, "");
    item = item.replace(/amp/gi, "");
    item = item.replace(/<br[^<>]*>/gis, "");

    item = item.replace(/<button[^<>]*>/gis, "");
    item = item.replace(/<\/button>/g, "");
    item = item.replace(/<p[^<>]*>/g, "");
    item = item.replace(/<\/p>/g, "");
    item = item.replace(/<b[^<>]*>/g, "");
    item = item.replace(/<\/b>/g, "");
    // 过滤掉停顿符号
    item = item.replace(/连续/g, "[w0]");
    item = item.replace(/0.5s/g, "[p500]");
    item = item.replace(/1s/g, "[p1000]");
    item = item.replace(/2s/g, "[p2000]");

    return item;
  }

  html2Text(item: any) {
    item = item.replace(/\[p500\]/g, "");
    item = item.replace(/\[p1000\]/g, "");
    item = item.replace(/\[p2000\]/g, "");
    item = item.replace(/\[w0\]/g, "");

    item = item.replace(/<div[^<>]*>/gis, "");
    item = item.replace(/<\/div>/g, "");

    item = item.replace(/<tbody[^<>]*>/gis, "");
    item = item.replace(/<tr[^<>]*>/gis, "");
    item = item.replace(/<td[^<>]*>/gis, "");
    item = item.replace(/<\/td>/g, "");
    item = item.replace(/<\/tr>/g, "");
    item = item.replace(/<\/tbody>/g, "");
    item = item.replace(/<table[^<>]*>/gis, "");
    item = item.replace(/<\/table>/g, "");

    item = item.replace(/\n/g, "");
    item = item.replace(/&/gi, "");
    item = item.replace(/;/gi, "");
    item = item.replace(/nbsp/gi, "");
    item = item.replace(/amp/gi, "");
    item = item.replace(/<br[^<>]*>/gis, "");

    item = item.replace(/<colgroup[^<>]*>/gis, "");
    item = item.replace(/<col[^<>]*>/gis, "");
    item = item.replace(/<\/col>/g, "");
    item = item.replace(/<\/colgroup>/g, "");

    // 中文双引号过滤
    item = item.replace(/ldquo/g, '"');
    item = item.replace(/rdquo/g, '"');

    item = item.replace(/<span[^<>]*>/gis, "");
    item = item.replace(/<font[^<>]*>/gis, "");
    item = item.replace(/<\/font>/g, "");
    item = item.replace(/<\/span>/g, "");
    item = item.replace(/<button[^<>]*>/gis, "");
    item = item.replace(/<\/button>/g, "");
    item = item.replace(/<p[^<>]*>/g, "");
    item = item.replace(/<\/p>/g, "");
    item = item.replace(/<b[^<>]*>/g, "");
    item = item.replace(/<\/b>/g, "");
    // 过滤掉停顿符号
    item = item.replace(/连续/g, "");
    item = item.replace(/0.5s/g, "");
    item = item.replace(/1s/g, "");
    item = item.replace(/2s/g, "");
    // 过滤掉音调的说明符号
    item = item.replace(/\[[^<>]{0,8}\]/gis, "");
    return item;
  }

  // 插入停顿 转换  Px -> button
  px2Button(item: string) {
    item = item.replace(/\[p500\]/g, "<button disabled>0.5s</button>");
    item = item.replace(/\[p1000\]/g, "<button disabled>1s</button>");
    item = item.replace(/\[p2000\]/g, "<button disabled>2s</button>");
    item = item.replace(
      /\[w0\]/g,
      "<button style='font-size: 12px;' disabled>连续</button>"
    );
    return item;
  }
}
